<script lang="ts" setup>
import { onMounted, onUnmounted, useTemplateRef } from 'vue';
import AlternateMarquee from '@/home/components/AlternateMarquee.vue';
import { StarfieldRenderer } from '@/home/utils/starfield';
// import logo from '@/home/assets/common/logo-300x300.png?inline';

const canvasRef = useTemplateRef('canvasEl');
const containerRef = useTemplateRef('containerEl');
let starfield: StarfieldRenderer | null = null;

onMounted(() => {
  if (canvasRef.value && containerRef.value) {
    // 初始化星空渲染器
    starfield = new StarfieldRenderer(canvasRef.value, {
      // 星星配置
      starCount: 50,
      minStarSize: 10,
      maxStarSize: 15,
      starSpeed: 0.2,
      starOpacity: 0.7,
      twinkleSpeed: 0.01,
      // 星星颜色
      starColors: ['#1281FF', '#0D47A1', '#1565C0', '#1976D2', '#1E88E5', '#2196F3', '#42A5F5'],
      // starShapes: ['circle', 'square', 'triangle', 'star', 'diamond', 'pentagon', 'hexagon', 'heart', 'cross', 'moon', 'cog', 'flower', 'spiral', 'crescent', 'arrow', 'custom'],
      starShapes: ['star'],
      // customStarTexture: logo,
      // 流星配置
      meteorProbability: 0.01,
      meteorSpeed: 2,
      meteorLength: 80,
      meteorColors: ['#0D47A1'],
      // 视差效果
      parallaxIntensity: 0.2,
    });

    starfield.setEventElement(containerRef.value);
  }
});

onUnmounted(() => {
  if (starfield) {
    starfield.destroy();
    starfield = null;
  }
});
</script>

<template>
  <section ref="containerEl" class="page-home-banner relative min-h-700 overflow-hidden bg-#F9FCFF">
    <canvas ref="canvasEl" class="pointer-events-none absolute inset-0 h-full w-full"></canvas>

    <div class="relative z-10 mx-auto max-w-1200 flex flex-nowrap gap-x-26">
      <div class="w-568 flex-shrink-0 py-154">
        <h1 class="my-0 text-nowrap text-46 text-#292D33 font-800 leading-60">
          <span>OPENATOM FOUNDATION</span>
          <AlternateMarquee>
            {{ $t('home.slogan') }}
          </AlternateMarquee>
        </h1>

        <p class="mb-0 mt-40 text-16 text-#9497A1 font-400 leading-34">
          {{ $t('websiteDescription') }}
        </p>

        <div class="mt-96 flex justify-between">
          <RouterLink to="/cooperation" class="button-glow pulse-animation h-54 w-171 flex-center rounded-6 bg-#1281FF px-12 text-16 text-white font-600 leading-24 no-underline shadow-[0px_12px_30px_rgba(24,92,255,0.18)]">
            <span class="truncate">{{ $t('home.banner.button1') }}</span>
          </RouterLink>
          <RouterLink to="/cooperation/project" class="button-glow h-54 w-171 flex-center border-1 border-#D6DDEB rounded-6 border-solid px-12 text-16 text-#292D33 font-400 leading-24 no-underline">
            <span class="truncate">{{ $t('home.banner.button2') }}</span>
          </RouterLink>
          <RouterLink to="/cooperation" class="button-glow h-54 w-171 flex-center border-1 border-#D6DDEB rounded-6 border-solid px-12 text-16 text-#292D33 font-400 leading-24 no-underline">
            <span class="truncate" :title="$t('home.banner.button3')">{{ $t('home.banner.button3') }}</span>
          </RouterLink>
        </div>
      </div>

      <div class="flex-y-center">
        <img src="@/home/assets/home/banner1.png" alt="" class="block h-621 w-auto">
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.button-glow {
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.button-glow::after {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  transition: width 0.3s ease, height 0.3s ease;
  content: "";
  pointer-events: none;
}

.button-glow:hover::after {
  width: 300px;
  height: 300px;
}

.button-glow:hover {
  box-shadow: 0 10px 25px rgba(24, 92, 255, 0.25);
  transform: translateY(-2px);
}

@keyframes pulse-glow {
  0% {
    box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.4);
  }

  70% {
    box-shadow: 0 0 0 10px rgba(59, 130, 246, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(59, 130, 246, 0);
  }
}

.pulse-animation {
  animation: pulse-glow 2s infinite;
}

@media (prefers-reduced-motion: reduce) {
  .button-glow::after,
  .button-glow:hover::after,
  .pulse-animation {
    box-shadow: none;
    transform: none;
    transition: none;
    animation: none;
  }
}
</style>
